<template>
  <v-app
    :style="`background-image:url('/images/white-1.jpg');background-repeat:repeat;color:${getSecondaryColor}`"
  >
    <router-view></router-view>
  </v-app>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
  },
  name: "App",
});
</script>
